import { HomeComponent } from './home/home.component';
import { GetStartedComponent } from './getstarted/getstarted.component';
import { SearchService } from './../../core/services/search.service';
import { SearchContainer } from './search.container';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NewSearchComponent } from './newsearch/newsearch';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/components/shared.module';
import { FormsModule } from '@angular/forms';
import { NouisliderModule } from 'ng2-nouislider';
import { Ng5SliderModule } from 'ng5-slider';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { DesktopFormComponent } from './desktopform/desktopform';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field/';

import { YouTubePlayerModule } from '@angular/youtube-player';

import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxSliderModule } from '@angular-slider/ngx-slider';

const routes: Routes = [
    { path: '', component: GetStartedComponent, pathMatch: 'full' },
    { path: 'search', component: NewSearchComponent, pathMatch: 'full' },
  ];
/**
 * Search Module: this module is responsible for handling the search functionality
 * of the application. This lazy module is loaded when the user visits the base url
 * of the app '/'.
 */
@NgModule({
  imports: [
      CommonModule,
      RouterModule.forRoot(routes, {anchorScrolling: 'enabled'}),
      NgbModule,
      SharedModule,
      FormsModule,
      NouisliderModule,
      Ng5SliderModule,
      MatSelectModule,
      MatFormFieldModule,
      NgMultiSelectDropDownModule.forRoot(),
      NgxSpinnerModule,
      NgxSliderModule,
      YouTubePlayerModule
    ],
  declarations: [
      HomeComponent,
      GetStartedComponent,
      NewSearchComponent,
      DesktopFormComponent
    ],
    exports: [ RouterModule ],

    providers: [
      SearchContainer,
      SearchService
    ]
})
export class SearchModule {}
